import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';
import { Product } from 'src/app/models/core/product.model';
import { Share } from '@capacitor/share';
import { ShareMicrositeStateService } from 'src/app/services/event/share-microsite-state.service';

@Component({
  selector: 'app-share-promotional-link',
  templateUrl: './share-promotional-link.component.html',
  styleUrls: ['./share-promotional-link.component.scss'],
  standalone: false
})
export class SharePromotionalLinkComponent implements OnInit {

  isNative = false;
  @Input() securityPhrase!: string;
  @Input() product!: Product;
  private sellerCode = this.shareMicrositeState.sellerCode();

  constructor(
    private modalCtrl: ModalController,
    private toast: CustomToastService,
    private translate: TranslateService,
    private shareMicrositeState: ShareMicrositeStateService,
  ) { }

  ngOnInit() {
    this.isNative = Capacitor.isNativePlatform();
  }

  get shareUrl(): string {
    return `${environment.ecommerceDomain}/buy-product/${this.product.uuid}?code=${this.sellerCode}`;
  }

  get shareMessageToCopy(): string {
    return `${this.shareUrl}`;
  }

  copyShareMessageToClipboard(
    successMsg = this.translate.instant('share-microsite.copy-link-success'),
    errorMsg = this.translate.instant('share-microsite.copy-link-error')
  ) {
    navigator.clipboard.writeText(this.shareMessageToCopy).then(() => {
      this.toast.show(successMsg, 3000, 'success');
    }).catch(() => {
      this.toast.show(errorMsg, 3000, 'error');
    });
  }

  shareWhatsApp() {
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(this.shareMessageToCopy)}`;
    window.open(url, '_blank');
  }

  shareInstagram() {
    const instaSuccess = this.translate.instant('share-microsite.instagram-copy-success');

    this.copyShareMessageToClipboard(instaSuccess);
    setTimeout(() => {
      window.open('https://www.instagram.com/accounts/login/?next=/', '_blank');
    }, 2100);
  }

  async shareMessageNative() {
    this.modalCtrl.dismiss();
    try {
      await Share.share({
        title: 'Compartir evento',
        text: this.shareMessageToCopy,
        dialogTitle: 'Compartir con...'
      });
    } catch (error) {
      console.error('Error al compartir:', error);
    }
  }

}
